// Logo de marque (compagnie, sinon plateforme) avec repli sur l'icône autobus.
import { useEffect, useState } from "react";
import { Bus } from "lucide-react";
import api from "@/lib/api";

const CACHE = "innova.logo";
const EVENT = "innova:logo-updated";

export const notifyLogoChanged = () => {
  try { localStorage.removeItem(CACHE); } catch { /* quota */ }
  if (typeof window !== "undefined") window.dispatchEvent(new Event(EVENT));
};

export function useLogo({ platform = false } = {}) {
  const [logo, setLogo] = useState(() => {
    try { return localStorage.getItem(CACHE) || null; } catch { return null; }
  });
  useEffect(() => {
    let alive = true;
    const fetchLogo = () => api.get(platform ? "/branding/platform" : "/branding")
      .then((r) => {
        if (!alive) return;
        setLogo(r.data.logo || null);
        try {
          if (r.data.logo) localStorage.setItem(CACHE, r.data.logo);
          else localStorage.removeItem(CACHE);
        } catch { /* quota */ }
      })
      .catch(() => {});
    fetchLogo();
    window.addEventListener(EVENT, fetchLogo);
    return () => { alive = false; window.removeEventListener(EVENT, fetchLogo); };
  }, [platform]);
  return logo;
}

export default function BrandLogo({ platform = false, className = "", fallbackClassName = "", size = 36 }) {
  const logo = useLogo({ platform });
  if (logo) {
    return (
      <img src={logo} alt="Logo" data-testid="brand-logo"
        style={{ maxHeight: size, maxWidth: size * 4 }}
        className={`object-contain ${className}`} />
    );
  }
  return (
    <div className={`rounded-md bg-primary flex items-center justify-center ${fallbackClassName}`}
      style={{ width: size, height: size }} data-testid="brand-logo-fallback">
      <Bus className="w-5 h-5 text-primary-foreground" />
    </div>
  );
}
